import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { AuthService } from '../auth/auth.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { Router } from "@angular/router";
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { faPen } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnDestroy {
  @ViewChild('otpInput') otpInput!: ElementRef<HTMLInputElement>;
  loginForm!: FormGroup;
  isLoading  : boolean= false;
  otpSent: boolean = false;
  errorMessage: any;
  companyDetails : any;
  errorLogin: any;
  resendCountdown: number = 0;
  private timerInterval: any;
  protected readonly faPen = faPen;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly router: Router,
  ) {
    this.loginForm = this.formBuilder.group({
      username: [
        '',
        [
          Validators.required,
          Validators.pattern(RegExpPatterns.MobilePattern),
        ],
      ],
      otp: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    });
  }


  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startCountdown(): void {
    this.resendCountdown = 60;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      if (this.resendCountdown > 0) {
        this.resendCountdown--;
      } else {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  sendOtp(): void {
    if (this.loginForm.controls['username']?.invalid) {
      return;
    }
    this.storageService.clearLocalStorage();
    this.storageService.clearSessionStorage();
    this.isLoading = true;
    this.errorMessage = '';
    const payload = {
      phoneNumber: this.loginForm.controls['username']?.value.toString()
    };
    this.authService.getLoginOtp(payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.otpSent = true;
        this.startCountdown();
        setTimeout(() => {
          this.otpInput?.nativeElement?.focus();
        }, 50);
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message || 'Failed to send OTP. Please try again.';
        this.isLoading = false;
        this.storageService.clearLocalStorage();
        this.storageService.clearSessionStorage();
      }
    });
  }

  goBack(): void {
    this.otpSent = false;
    this.loginForm.controls['otp']?.reset();
    this.errorMessage = '';
    this.resendCountdown = 0;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  onLogin(): void {
    if (this.loginForm.invalid) {
      return;
    }
    this.isLoading = true;
    this.errorMessage = '';
    const rawValue = this.loginForm.getRawValue();
    const payload = {
      phoneNumber: rawValue.username.toString(),
      otp: rawValue.otp.toString()
    };
    this.authService.loginUsingOtp(payload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.storageService.setDataToLocalStorage(
          StorageKeys.ACCESS_TOKEN,
          response.data.token
        );
        this.storageService.setDataToLocalStorage(
          StorageKeys.REFRESH_TOKEN,
          response.data.refreshToken
        );
        this.storageService.setDataToLocalStorage(
          StorageKeys.REFRESH_AT,
          Date.now() + 7.5 * 60 * 60 * 1000
        );
        this.storageService.setDataToLocalStorage(
          StorageKeys.COMPANY_ID,
          response.data.company
        );
        this.getSelfDetails();
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message || 'Invalid OTP or login failed.';
        this.isLoading = false;
      }
    });
  }

  getSelfDetails() {
    this.authService.getSelfDetails().subscribe({
      next:(res: any)=>{
        this.storageService.setDataToLocalStorage(
          StorageKeys.SELF_DETAILS,
          res.data
        );
        if (res.data.enrollmentType == 'Admin') {
          this.router.navigate(['/admin/sdex/company']);
        } else {
          this.router.navigate(['/']);
        }
      },
      error:(error) => {
        this.errorMessage = error?.error?.error?.message;
        this.storageService.clearLocalStorage();
        this.storageService.clearSessionStorage();
      }
    })
  }


    onInput(event: Event): void {
      this.errorMessage = '';
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.value.length > 10) {
        inputElement.value = inputElement.value.slice(0, 10);
        this.loginForm.controls['username'].setValue(inputElement.value);
      }
    }

    onOtpInput(event: Event): void {
      this.errorMessage = '';
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.value.length > 6) {
        inputElement.value = inputElement.value.slice(0, 6);
        this.loginForm.controls['otp'].setValue(inputElement.value);
      }
    }

}
